import {DataGrid} from '@mui/x-data-grid'
import Paper from '@mui/material/Paper'

const PaginatedDataTable = ({records, columns, height, ...props}) => (
  <Paper sx={{height, width: '100%'}}>
    <DataGrid
      loading={props.isLoading}
      rows={records}
      rowCount={props.rowCount}
      columns={columns}
      initialState={{pagination: {paginationModel: props.paginationModel}}}
      pageSizeOptions={[12, 24]}
      checkboxSelection
      sx={{border: 0}}
      paginationMode='server'
      onPaginationModelChange={props.onPaginationModelChange}
    />
  </Paper>
)

export default PaginatedDataTable